"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var THREE = _interopRequireWildcard(require("three"));
var _eventHub = _interopRequireDefault(require("@/utils/eventHub"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// 创建透视相机
var camera = new THREE.PerspectiveCamera(75, window.innerHeight / window.innerHeight, 1, 100000);
// 设置相机位置
// object3d具有position，属性是1个3维的向量
camera.position.set(100, 100, 100);
var CameraModule = /*#__PURE__*/function () {
  function CameraModule() {
    var _this = this;
    (0, _classCallCheck2.default)(this, CameraModule);
    this.activeCamera = camera;
    this.collection = {
      default: camera
    };
    _eventHub.default.on("toggleCamera", function (name) {
      _this.setActive(name);
    });
  }
  return (0, _createClass2.default)(CameraModule, [{
    key: "add",
    value: function add(name, camera) {
      this.collection[name] = camera;
    }
  }, {
    key: "setActive",
    value: function setActive(name) {
      this.activeCamera = this.collection[name];
    }
  }]);
}();
var _default = exports.default = new CameraModule();